import { Button, Header, Icon, Segment } from "semantic-ui-react";
import AccordionItem from "./AccordionItem";
import { SettingsContext } from "../context";
import { useContext, useState } from "react";

function FileUpload() {
  const { setThumbnail, setLowGlb } = useContext(SettingsContext);
  const [thumbnailName, setThumbnailName] = useState();
  const [lowGlbFileName, setLowGlbFileName] = useState();

  const handleLowGlbDrop = (e) => {
    const file = e.dataTransfer.files[0];
    setLowGlbFileName(e.dataTransfer.files[0].name);
    setLowGlb(file);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div>
      {/*<br></br>

      <div className="filupload">
        <div
          id="lowglb"
          className="dropZoneFile"
          onDrop={(e) => handleLowGlbDrop(e)}
          onDragOver={(e) => handleDragOver(e)}
          onDragEnter={(e) => handleDragEnter(e)}
          onDragLeave={(e) => handleDragLeave(e)}
        ></div>
  </div>*/}
    </div>
  );
}

export default FileUpload;
